import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {

  constructor(public afs: AngularFirestore) {
    this.afs.firestore.settings({ timestampsInSnapshots: true });
  }

  getObject(document, id) {
    return this.afs.collection(document).doc(id);
  }

  getList(document) {
    return this.afs.collection(document);
  }

  getOrderList(document, field) {
    return this.afs.collection(document, ref => ref.orderBy(field, 'desc'));
  }

  getOrderListAsc(document, field) {
    return this.afs.collection(document, ref => ref.orderBy(field, 'asc'));
  }

  addItem(document, item) {
    return this.afs.collection(document).add(item);
  }

  removeItem(document, key) {
    return this.afs.collection(document).doc(key).delete();
  }

  updateItem(document, key, data) {
    return this.afs.collection(document).doc(key).update(data);
  }

  query(document, options) {
    return this.afs.collection(document, options);
  }

  getCollection(document, item, collection){
    return this.afs.collection(document).doc(item).collection(collection);
  }

  getCollectionOrdener(document, item, collection, field){
    return this.afs.collection(document).doc(item).collection(collection, ref => ref.orderBy(field, 'asc') );
  }

  getCollectionOrdenerDescLimit(document, item, collection, field, limit){
    return this.afs.collection(document).doc(item).collection(collection, ref => ref.orderBy(field, 'desc').limit(limit) );
  }

  addItemCollection(document, itemcolecao , collection, item){    
    return this.afs.collection(document).doc(itemcolecao).collection(collection).add(item);
  }

  updateItemCollection(document, itemcolecao , collection, item){    
    return this.afs.collection(document).doc(itemcolecao).collection(collection).doc(item.id).update(item);
  }

  removeItemCollection(document, itemcolecao , collection, item){    
    return this.afs.collection(document).doc(itemcolecao).collection(collection).doc(item.id).delete();
  }

  getItemCollection(document, itemcolecao , collection, id){    
    return this.afs.collection(document).doc(itemcolecao).collection(collection).doc(id);
  }

  getItemCollectionWhereLimit(document, itemcolecao , collection, options){
    return this.afs.collection(document).doc(itemcolecao).collection(collection, options);
  }
  
}
